/**
 * TrendMart Product Detail Page (PDP) Controller
 */
function initPDP() {
  const productSection = document.querySelector('[data-section-type="product"]');
  if (!productSection) return;

  const productDataEl = productSection.getAttribute('data-product-json');
  if (!productDataEl) return;

  let product;
  try {
    product = JSON.parse(productDataEl);
  } catch (e) {
    console.error('Error parsing product JSON:', e);
    return;
  }

  // Media Gallery Thumbnail Click
  const thumbs = productSection.querySelectorAll('[data-thumbnail-id]');
  const mainMediaImg = productSection.querySelector('[data-main-media]');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const newSrc = thumb.getAttribute('data-thumbnail-src');
      if (mainMediaImg && newSrc) {
        mainMediaImg.src = newSrc;
        if (mainMediaImg.hasAttribute('srcset')) {
          mainMediaImg.removeAttribute('srcset');
        }
      }
    });
  });

  // Variant Option Selection
  const optionGroups = productSection.querySelectorAll('.tm-option-group');
  const variantIdInput = productSection.querySelector('[data-selected-variant-id]');
  const addToCartBtn = productSection.querySelector('[data-add-to-cart]');
  const addToCartText = productSection.querySelector('[data-add-to-cart-text]');
  const priceContainer = productSection.querySelector('[data-price-container]');
  const stockStatus = productSection.querySelector('[data-stock-status]');
  const skuContainer = productSection.querySelector('[data-product-sku]');
  const stickyPrice = productSection.querySelector('[data-sticky-price]');

  const getSelectedOptions = () => {
    const selected = [];
    optionGroups.forEach((group, index) => {
      // 1. Check for checked radio inside this group
      const checkedRadio = group.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        selected[index] = checkedRadio.value;
      } else {
        // 2. Check for active label or pill
        const activeOption = group.querySelector('.tm-pill-option.is-selected, [data-option-value].is-selected');
        if (activeOption) {
          selected[index] = activeOption.getAttribute('data-option-value') || activeOption.textContent.trim();
        } else {
          // 3. Fallback to first radio
          const firstRadio = group.querySelector('input[type="radio"]');
          if (firstRadio) {
            selected[index] = firstRadio.value;
          }
        }
      }
    });
    return selected;
  };

  const updateVariant = () => {
    const selectedOptions = getSelectedOptions();
    if (!product || !product.variants || !product.variants.length) return;

    const matchedVariant = product.variants.find(v => {
      return v.options.every((opt, index) => {
        return selectedOptions[index] !== undefined ? opt === selectedOptions[index] : true;
      });
    });

    if (matchedVariant) {
      // 1. Update hidden input(s) name="id"
      const idInputs = productSection.querySelectorAll('input[name="id"]');
      idInputs.forEach(input => {
        input.value = matchedVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // 2. Update URL (?variant=ID)
      if (window.history && window.history.replaceState) {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('variant', matchedVariant.id);
        window.history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());
      }

      // 3. Update Price
      if (priceContainer && window.TrendMart && TrendMart.utils && TrendMart.utils.formatMoney) {
        const onSale = matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price;
        const formattedPrice = TrendMart.utils.formatMoney(matchedVariant.price, TrendMart.moneyFormat);
        let priceHtml = `<div class="tm-price-box ${onSale ? 'tm-price--on-sale' : ''} ${!matchedVariant.available ? 'tm-price--sold-out' : ''}">`;
        priceHtml += `<div class="tm-price__container">`;
        if (onSale) {
          const formattedCompare = TrendMart.utils.formatMoney(matchedVariant.compare_at_price, TrendMart.moneyFormat);
          const savePercent = Math.round(((matchedVariant.compare_at_price - matchedVariant.price) * 100) / matchedVariant.compare_at_price);
          priceHtml += `<span class="visually-hidden">Sale price</span>`;
          priceHtml += `<span class="tm-price__current tm-price__current--sale">${formattedPrice}</span> `;
          priceHtml += `<span class="visually-hidden">Regular price</span>`;
          priceHtml += `<s class="tm-price__compare">${formattedCompare}</s> `;
          if (savePercent > 0) {
            priceHtml += `<span class="tm-badge tm-badge--sale" aria-hidden="true">-${savePercent}%</span>`;
          }
        } else {
          priceHtml += `<span class="visually-hidden">Regular price</span>`;
          priceHtml += `<span class="tm-price__current">${formattedPrice}</span>`;
        }
        priceHtml += `</div></div>`;
        priceContainer.innerHTML = priceHtml;
      }

      if (stickyPrice && window.TrendMart && TrendMart.utils && TrendMart.utils.formatMoney) {
        stickyPrice.textContent = TrendMart.utils.formatMoney(matchedVariant.price, TrendMart.moneyFormat);
      }

      // 4. Update SKU
      if (skuContainer) {
        const skuVal = skuContainer.querySelector('strong');
        if (skuVal) skuVal.textContent = matchedVariant.sku || '';
      }

      // 5. Update Stock Text & ATC Button State
      const atcText = (window.TrendMart && TrendMart.strings && TrendMart.strings.addToCart) || 'Add to Cart';
      const soldOutText = (window.TrendMart && TrendMart.strings && TrendMart.strings.soldOut) || 'Sold Out';

      if (matchedVariant.available) {
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('is-disabled');
        }
        if (addToCartText) addToCartText.textContent = atcText;
        if (stockStatus) {
          if (matchedVariant.inventory_quantity > 0 && matchedVariant.inventory_quantity <= 5) {
            stockStatus.className = 'tm-pdp-stock-status is-low-stock';
            stockStatus.innerHTML = `<span>Only ${matchedVariant.inventory_quantity} left in stock - order soon</span>`;
          } else {
            stockStatus.className = 'tm-pdp-stock-status';
            stockStatus.innerHTML = `<span>In Stock &bull; Ready to ship</span>`;
          }
        }
      } else {
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add('is-disabled');
        }
        if (addToCartText) addToCartText.textContent = soldOutText;
        if (stockStatus) {
          stockStatus.className = 'tm-pdp-stock-status is-low-stock';
          stockStatus.innerHTML = `<span style="color:var(--color-sale);">${soldOutText}</span>`;
        }
      }

      // 6. Swap Main Image
      let variantImageUrl = null;
      let variantImageId = null;

      if (matchedVariant.featured_image) {
        if (typeof matchedVariant.featured_image === 'string') {
          variantImageUrl = matchedVariant.featured_image;
        } else if (matchedVariant.featured_image.src) {
          variantImageUrl = matchedVariant.featured_image.src;
          variantImageId = matchedVariant.featured_image.id;
        }
      } else if (matchedVariant.featured_media) {
        if (matchedVariant.featured_media.preview_image && matchedVariant.featured_media.preview_image.src) {
          variantImageUrl = matchedVariant.featured_media.preview_image.src;
          variantImageId = matchedVariant.featured_media.id;
        }
      }

      if (variantImageUrl && mainMediaImg) {
        if (variantImageUrl.startsWith('//')) {
          variantImageUrl = 'https:' + variantImageUrl;
        }
        mainMediaImg.src = variantImageUrl;
        if (mainMediaImg.hasAttribute('srcset')) {
          mainMediaImg.removeAttribute('srcset');
        }
      }

      // 7. Sync active thumbnail
      if (variantImageId) {
        thumbs.forEach(t => {
          if (t.getAttribute('data-thumbnail-id') == variantImageId) {
            t.classList.add('is-active');
          } else {
            t.classList.remove('is-active');
          }
        });
      }

      // 8. Publish pubsub event
      if (window.TrendMart && TrendMart.pubsub) {
        TrendMart.pubsub.publish('variant:change', matchedVariant);
      }
    }
  };

  // Option selection events
  optionGroups.forEach(group => {
    const radios = group.querySelectorAll('.tm-pill-radio');
    const labels = group.querySelectorAll('.tm-pill-option');
    const labelVal = group.querySelector('[data-selected-option-value]');

    const selectOptionVal = (val) => {
      radios.forEach(r => {
        if (r.value === val) {
          r.checked = true;
        }
      });
      labels.forEach(l => {
        if (l.getAttribute('data-option-value') === val) {
          l.classList.add('is-selected');
        } else {
          l.classList.remove('is-selected');
        }
      });
      if (labelVal) labelVal.textContent = val;
      updateVariant();
    };

    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        selectOptionVal(radio.value);
      });
    });

    labels.forEach(label => {
      label.addEventListener('click', () => {
        const val = label.getAttribute('data-option-value');
        if (val) selectOptionVal(val);
      });
    });
  });

  // Delegated click listener on document for option chips
  document.addEventListener('click', (e) => {
    const pill = e.target.closest('.tm-pill-option');
    if (!pill) return;
    const group = pill.closest('.tm-option-group');
    if (!group) return;

    const val = pill.getAttribute('data-option-value') || pill.textContent.trim();
    if (!val) return;

    // Check matching radio
    let radio = null;
    try {
      radio = group.querySelector(`input[type="radio"][value="${CSS.escape ? CSS.escape(val) : val}"]`);
    } catch (err) {
      const allRadios = group.querySelectorAll('input[type="radio"]');
      allRadios.forEach(r => {
        if (r.value === val) radio = r;
      });
    }

    if (radio) {
      radio.checked = true;
    }

    // Update active label
    group.querySelectorAll('.tm-pill-option').forEach(p => p.classList.remove('is-selected'));
    pill.classList.add('is-selected');

    // Update displayed selected value
    const labelVal = group.querySelector('[data-selected-option-value]');
    if (labelVal) labelVal.textContent = val;

    updateVariant();
  });

  // Initial sync on page load
  updateVariant();

  // Sticky ATC Scroll Trigger
  const stickyAtcBar = document.querySelector('[data-sticky-atc-bar]');
  const stickyAtcTrigger = document.querySelector('[data-sticky-atc-trigger]');
  const mainAtcBtn = document.querySelector('[data-add-to-cart]');

  if (stickyAtcBar && mainAtcBtn) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          stickyAtcBar.classList.add('is-visible');
        } else {
          stickyAtcBar.classList.remove('is-visible');
        }
      });
    }, { rootMargin: '-60px 0px 0px 0px' });

    observer.observe(mainAtcBtn);

    if (stickyAtcTrigger) {
      stickyAtcTrigger.addEventListener('click', () => {
        mainAtcBtn.click();
      });
    }
  }

  // Size Guide Modal Handlers
  const sizeGuideModal = document.querySelector('[data-size-guide-modal]');
  const sizeGuideOpenBtns = document.querySelectorAll('[data-size-guide-open]');
  const sizeGuideCloseBtns = document.querySelectorAll('[data-size-guide-close]');

  const openSizeGuide = () => {
    if (sizeGuideModal) {
      sizeGuideModal.classList.add('is-open');
      sizeGuideModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  };

  const closeSizeGuide = () => {
    if (sizeGuideModal) {
      sizeGuideModal.classList.remove('is-open');
      sizeGuideModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };

  sizeGuideOpenBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openSizeGuide();
    });
  });

  sizeGuideCloseBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeSizeGuide();
    });
  });

  if (sizeGuideModal) {
    sizeGuideModal.addEventListener('click', (e) => {
      if (e.target === sizeGuideModal) {
        closeSizeGuide();
      }
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sizeGuideModal && sizeGuideModal.classList.contains('is-open')) {
      closeSizeGuide();
    }
  });

}

// Support both DOMContentLoaded and immediate execution if already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPDP);
} else {
  initPDP();
}
